import React from 'react';
import PlanChangeTableContainer from '../containers/PlanChangeTableContainer';
import SaunaImageContainer from '../containers/SaunaImageContainer';

const PlanSummary = ({ changeRows, sendPlan}) => (
    <div className="page">
        <SaunaImageContainer/>
        <h1>Kooste valinnoistanne</h1>
        <PlanChangeTableContainer rows={changeRows}></PlanChangeTableContainer>
        {/* <div className="orangeButton">
            <span className="buttonTxt">Lataa kooste muutoksista koneellesi</span>
        </div>*/}
        <div className="orangeButton" onClick={() => sendPlan()}><span className="buttonTxt">&#8594;  {"Lähetä muutokset"}</span></div>
    </div>
);
export default PlanSummary